import {Directive, EventEmitter, HostListener, Output} from '@angular/core';

@Directive({
  selector: '[appFileUpload]'
})
export class FileUploadDirective {

  @Output()
  fileAdded = new EventEmitter<File>();

  constructor() {
  }

  @HostListener('drop', ['$event'])
  onDrop(event) {
    event.preventDefault();
    for (let index = 0; index < event.dataTransfer.files.length; index++) {
      this.fileAdded.emit(event.dataTransfer.files.item(index));
    }
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event) {
    event.preventDefault();
  }

  @HostListener('dragleave')
  public onDragLeave() {
  }

}
